<template>
  <a-card class="mb-3">
    <template slot="title">
      <b style="color: red">区域限制</b>
    </template>
    <a-button slot="extra" type="primary" icon="plus-circle" @click="onAddAddress" ghost>新增
    </a-button>
    <a-form-model ref="addressFormRef" :model="addressForm" class="exi_form item_100"  :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
      <!--新增专家-->
      <div class="model-expert" v-if="addressForm.data.length>0">
        <a-row v-for="(item,index) in addressForm.data" :gutter="20" type="flex" align="middle">
          <a-col :span="7">
            <a-form-model-item label="地区选择"
                               :rules="{required: true, message: '请选择地区', trigger: 'blur'}"
                               :prop="'data.'+index+'.address'">
              <dict-cascader v-model="item.address"
                             dictKey="COUNTRY.CITY"
                             placeholder="地区选择"
                             style="width: 100%"
              />

            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="专家数量"
                               :rules="{required: true, message: '请输入专家数量', trigger: 'blur'}"
                               :prop="'data.'+index+'.expertNum'">

              <a-input-number placeholder="专家数量" style="width: 100%"
                              v-model="item.expertNum"
                              :min="1"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-button @click="delAddress(item.id)"
                      type="danger" ghost>
              移除
            </a-button>
          </a-col>
        </a-row>
      </div>
      <a-empty :image="simpleImage" v-else>
        <span slot="description">暂无数据，点击右上角新增区域限制</span>
      </a-empty>
    </a-form-model>

  </a-card>

</template>
<script>
import { PageView } from '@/layouts'
import { Empty } from 'ant-design-vue'
import DictCascader from '@/components/dict/DictCascader.vue'

const uuidv4 = require('uuid/v4')

export default {
  name: 'AddressForm',
  comments: {
    DictCascader
  },
  beforeCreate () {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  props: {
    addressForm: {
      type: Object,
      default () {
        return {
          data: [],
        }
      }
    }
  },
  components: {
    DictCascader,
    PageView,
  },
  data () {
    return {}
  },
  computed: {},
  created () {
  },
  methods: {
    onAddAddress () {
      const data = {
        id: uuidv4(),
        applyId: this.applyId,
        address: '44,4401',
        expertNum: 1
      }
      this.addressForm.data.push(data)
    },
    delAddress (id) {
      const newData = this.addressForm.data.filter(item => item.id !== id)
      this.addressForm.data = [...newData]
    },
  }
}

</script>

<style scoped lang="less">

</style>
